import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useBiopharmaGroupState() {
  return useAppState();
}

export function useBiopharmaGroupActions() {
  const dispatch = useAppDispatch();

  function initializeState(id) {
    dispatch((appState) => ({
      ...appState,
      biopharmaGroup: {
        id,
        name: null,
        weblinks: [],
        locations: [],
        categories: [],
        externalJobBoards: [],
      },
      loading: true,
      newExternalJobBoardModalIsOpen: false,
      newExternalJobBoard: {
        biopharmaGroupId: id,
        url: '',
      },
      updateExternalJobBoardModalIsOpen: false,
      updateExternalJobBoard: {
        biopharmaGroupId: id,
        externalJobBoardId: '',
        url: '',
      },
      deleteExternalJobBoardModalIsOpen: false,
      deleteExternalJobBoard: {
        biopharmaGroupId: id,
        externalJobBoardId: '',
      },
      deleteJobDescriptionModalIsOpen: false,
      deleteJobDescription: {
        biopharmaGroupId: id,
        jobDescriptionId: '',
        title: '',
      },
      closeJobDescriptionModalIsOpen: false,
      closeJobDescription: {
        biopharmaGroupId: id,
        jobDescriptionId: '',
        title: '',
      },
      reopenJobDescriptionModalIsOpen: false,
      reopenJobDescription: {
        biopharmaGroupId: id,
        jobDescriptionId: '',
        title: '',
      },
      archiveJobDescriptionModalIsOpen: false,
      archiveJobDescription: {
        biopharmaGroupId: id,
        jobDescriptionId: '',
        title: '',
      },
      updateJobDescriptionModalIsOpen: false,
      updateJobDescription: {
        biopharmaGroupId: id,
        jobDescriptionId: '',
        title: '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openNewExternalJobBoardModal() {
    dispatch((appState) => ({
      ...appState,
      newExternalJobBoardModalIsOpen: true,
    }));
  }

  function closeNewExternalJobBoardModal() {
    dispatch((appState) => ({
      ...appState,
      newExternalJobBoardModalIsOpen: false,
    }));
  }

  function updateNewExternalJobBoardUrl(newExternalJobBoardUrl) {
    dispatch((appState) => ({
      ...appState,
      newExternalJobBoard: {
        ...appState.newExternalJobBoard,
        url: newExternalJobBoardUrl,
      },
    }));
  }

  function openUpdateExternalJobBoardModal(externalJobBoard) {
    dispatch((appState) => ({
      ...appState,
      updateExternalJobBoardModalIsOpen: true,
      updateExternalJobBoard: {
        ...appState.updateExternalJobBoard,
        externalJobBoardId: externalJobBoard.id,
        url: externalJobBoard.url,
      },
    }));
  }

  function closeUpdateExternalJobBoardModal() {
    dispatch((appState) => ({
      ...appState,
      updateExternalJobBoardModalIsOpen: false,
      updateExternalJobBoard: {
        ...appState.updateExternalJobBoard,
        externalJobBoardId: '',
        url: '',
      },
    }));
  }

  function updateUpdateExternalJobBoardUrl(updateExternalJobBoardUrl) {
    dispatch((appState) => ({
      ...appState,
      updateExternalJobBoard: {
        ...appState.updateExternalJobBoard,
        url: updateExternalJobBoardUrl,
      },
    }));
  }

  function openDeleteExternalJobBoardModal(externalJobBoard) {
    dispatch((appState) => ({
      ...appState,
      deleteExternalJobBoardModalIsOpen: true,
      deleteExternalJobBoard: {
        ...appState.deleteExternalJobBoard,
        externalJobBoardId: externalJobBoard.id,
      },
    }));
  }

  function closeDeleteExternalJobBoardModal() {
    dispatch((appState) => ({
      ...appState,
      deleteExternalJobBoardModalIsOpen: false,
      deleteExternalJobBoard: {
        ...appState.deleteExternalJobBoard,
        externalJobBoardId: '',
      },
    }));
  }

  function openDeleteJobDescriptionModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      deleteJobDescriptionModalIsOpen: true,
      deleteJobDescription: {
        ...appState.deleteJobDescription,
        jobDescriptionId: jobDescription.id,
        title: jobDescription.title,
      },
    }));
  }

  function closeDeleteJobDescriptionModal() {
    dispatch((appState) => ({
      ...appState,
      deleteJobDescriptionModalIsOpen: false,
      deleteJobDescription: {
        ...appState.deleteJobDescription,
        jobDescriptionId: '',
        title: '',
      },
    }));
  }

  function openCloseJobDescriptionModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      closeJobDescriptionModalIsOpen: true,
      closeJobDescription: {
        ...appState.closeJobDescription,
        jobDescriptionId: jobDescription.id,
        title: jobDescription.title,
      },
    }));
  }

  function closeCloseJobDescriptionModal() {
    dispatch((appState) => ({
      ...appState,
      closeJobDescriptionModalIsOpen: false,
      closeJobDescription: {
        ...appState.closeJobDescription,
        jobDescriptionId: '',
        title: '',
      },
    }));
  }

  function openReopenJobDescriptionModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      reopenJobDescriptionModalIsOpen: true,
      reopenJobDescription: {
        ...appState.reopenJobDescription,
        jobDescriptionId: jobDescription.id,
        title: jobDescription.title,
      },
    }));
  }

  function closeReopenJobDescriptionModal() {
    dispatch((appState) => ({
      ...appState,
      reopenJobDescriptionModalIsOpen: false,
      reopenJobDescription: {
        ...appState.reopenJobDescription,
        jobDescriptionId: '',
        title: '',
      },
    }));
  }

  function openArchiveJobDescriptionModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      archiveJobDescriptionModalIsOpen: true,
      archiveJobDescription: {
        ...appState.archiveJobDescription,
        jobDescriptionId: jobDescription.id,
        title: jobDescription.title,
      },
    }));
  }

  function closeArchiveJobDescriptionModal() {
    dispatch((appState) => ({
      ...appState,
      archiveJobDescriptionModalIsOpen: false,
      archiveJobDescription: {
        ...appState.archiveJobDescription,
        jobDescriptionId: '',
        title: '',
      },
    }));
  }

  function openUpdateJobDescriptionModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      updateJobDescriptionModalIsOpen: true,
      updateJobDescription: {
        ...appState.updateJobDescription,
        jobDescriptionId: jobDescription.id,
        title: jobDescription.title,
      },
    }));
  }

  function closeUpdateJobDescriptionModal() {
    dispatch((appState) => ({
      ...appState,
      updateJobDescriptionModalIsOpen: false,
      updateJobDescription: {
        ...appState.updateJobDescription,
        jobDescriptionId: '',
        title: '',
      },
    }));
  }

  function updateUpdateJobDescriptionTitle(title) {
    dispatch((appState) => ({
      ...appState,
      updateJobDescription: {
        ...appState.updateJobDescription,
        title,
      },
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openNewExternalJobBoardModal,
    closeNewExternalJobBoardModal,
    updateNewExternalJobBoardUrl,
    openUpdateExternalJobBoardModal,
    closeUpdateExternalJobBoardModal,
    updateUpdateExternalJobBoardUrl,
    openDeleteExternalJobBoardModal,
    closeDeleteExternalJobBoardModal,
    openDeleteJobDescriptionModal,
    closeDeleteJobDescriptionModal,
    openCloseJobDescriptionModal,
    closeCloseJobDescriptionModal,
    openReopenJobDescriptionModal,
    closeReopenJobDescriptionModal,
    openArchiveJobDescriptionModal,
    closeArchiveJobDescriptionModal,
    openUpdateJobDescriptionModal,
    closeUpdateJobDescriptionModal,
    updateUpdateJobDescriptionTitle,
    clearFeedback,
  };
}
